// extracted by mini-css-extract-plugin
export var container = "b5484";
export var fake = "_52085";
export var icon = "_6a20b";